const CATEGORY_OPTIONS_SEARCH = [
	{
		value: "barbershop",
		labelEN: "Barbershop",
		labelES: "Barbería",
		subCategories: [
			{
				value: "barbershop",
				labelEN: "Barbershop",
				labelES: "Barbería",
			},
		],
	},

	{
		value: "beauty_esthetics",
		labelEN: "Beauty & Aesthetics",
		labelES: "Belleza & Estética",
		subCategories: [
			{
				value: "all",
				labelEN: "All",
				labelES: "Todo",
			},
			{
				value: "hairsalon",
				labelEN: "Hair Salon",
				labelES: "Peluquería",
			},
			{
				value: "nails",
				labelEN: "Nails",
				labelES: "Uñas",
			},
			{
				value: "brows_lashes",
				labelEN: "Brows & Lashes",
				labelES: "Pestañas & Cejas",
			},
			{
				value: "makeup",
				labelEN: "Makeup",
				labelES: "Maquillaje",
			},
			{
				value: "facial_body_esthetics",
				labelEN: "Facial & Body Aesthetics",
				labelES: "Estética Facial & Corporal",
			},
			{
				value: "hair_removal",
				labelEN: "Hair Removal",
				labelES: "Depilación",
			},
			{
				value: "tattoos_piercing",
				labelEN: "Tattoos & Piercing",
				labelES: "Tatuajes y Piercing",
			},
		],
	},

	{
		value: "wellness",
		labelEN: "Wellness",
		labelES: "Bienestar",
		subCategories: [
			{
				value: "all",
				labelEN: "All",
				labelES: "Todo",
			},
			{
				value: "massage_spa",
				labelEN: "Massages & Spa",
				labelES: "Masajes & Spa",
			},
			{
				value: "body_therapies",
				labelEN: "Body Therapies",
				labelES: "Terapias Corporales",
			},
			{
				value: "yoga_pilates",
				labelEN: "Yoga / Pilates",
				labelES: "Yoga / Pilates",
			},
			{
				value: "fitness_training",
				labelEN: "Fitness & Personal Training",
				labelES: "Fitness & Personal Training",
			},
			{
				value: "zumba_dance",
				labelEN: "Zumba / Dance",
				labelES: "Zumba / Baile",
			},
			{
				value: "reiki_alternative",
				labelEN: "Reiki & Alternative Therapies",
				labelES: "Reiki & Terapias Alternativas",
			},
			{
				value: "nutrition_coaching",
				labelEN: "Nutrition & Wellness Coaching",
				labelES: "Nutrición & Coaching Wellness",
			},
		],
	},

	{
		value: "professional_services",
		labelEN: "Professional Services",
		labelES: "Servicios Profesionales",
		
		subCategories: [
			{
				value: "all",
				labelEN: "All",
				labelES: "Todo",
			},
			{
				value: "cleaning_services",
				labelEN: "Cleaning Services",
				labelES: "Servicios De Limpieza",
			},
			{
				value: "classes_tutoring",
				labelEN: "Classes & Tutoring",
				labelES: "Clases & Tutorías",
			},
			{
				value: "pets_grooming",
				labelEN: "Pets & Grooming",
				labelES: "Mascotas & Grooming",
			},
			{
				value: "freelance",
				labelEN: "Professional Freelancers",
				labelES: "Freelance profesional",
			},
		],
	},

	// {
	// 	value: "other",
	// 	labelEN: "Other",
	// 	labelES: "Otro",
	// 	subCategories: [
	// 		{
	// 			value: "other",
	// 			labelEN: "Other",
	// 			labelES: "Otro",
	// 		},
	// 	],
	// },
];

export default CATEGORY_OPTIONS_SEARCH;
